import { render, staticRenderFns } from "./MemberDetails.vue?vue&type=template&id=bee1a174&scoped=true&"
import script from "./MemberDetails.vue?vue&type=script&lang=js&"
export * from "./MemberDetails.vue?vue&type=script&lang=js&"
import style0 from "./MemberDetails.vue?vue&type=style&index=0&id=bee1a174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee1a174",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bee1a174')) {
      api.createRecord('bee1a174', component.options)
    } else {
      api.reload('bee1a174', component.options)
    }
    module.hot.accept("./MemberDetails.vue?vue&type=template&id=bee1a174&scoped=true&", function () {
      api.rerender('bee1a174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMembers/components/MemberDetails.vue"
export default component.exports